import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

const swiperTestimonialGallery = new Swiper('.block-related-work', {
  a11y: true,
  loop: false,
  slidesPerView: 1,
  spaceBetween: 20,
  autoHeight: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
        type: 'bullets',
      },
      slidesPerView: 3,
    },
  },
});
